import p256Plugin from './p256/plugin'
import secp256k1Plugin from './secp256k1/plugin'

export const plugins = [p256Plugin, secp256k1Plugin]

export default plugins
